import { AttributeView } from "./AttributeView";
import { DayType } from "@/geoMap/layerFactory/ETCLayerNameMonth";
import { RoadType } from "@/geoMap/layerFactory/ETCLayerName";
import { ExportValue } from "./ExportValue";
import GeoJSON from "ol/format/GeoJSON";
import { ISearchDateAttributeConvert } from "./ISearchDateAttributeConvert";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { CqlParameter } from "@/geoMap/net/CqlParameter";
import { WFSGetFeatureManager } from "@/geoMap/net/WFSGetFeatureManager";
import { AttributeValue } from "./AttributeValue";
import { ETCCodeUtil } from "./util/ETCCodeUtil";
import { parseTimeCode } from "./util/TimeCodeUtil";
import { Geometry } from "ol/geom";
/**
 * API通信用URL
 */
const URL_API = process.env.VUE_APP_XROAD_API_URL;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "etc20_2-7_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "etc20_2-7_yyyyMMdd_HHmmss.csv";

/**
 * 対象FeatureType
 */
const FEATURE_TYPE = FeatureType.EtcLinkMonth;

/**
 * 属性データ
 */
const PROPERTY_MAP = [
  {
    label: "交通調査基本区間番号",
    key: "交通調査基本区間番号",
    isSimple: true,
    isCommon: true,
  },
  {
    label: "上り・下りコード",
    key: "上り・下りコード",
    isSimple: true,
    isCommon: true,
  },
  { label: "算定年月", key: "算定年月", isSimple: true, isCommon: false },
  { label: "休平日区分", key: "休平日区分", isSimple: true, isCommon: false },
  { label: "指定時間", key: "指定時間", isSimple: true, isCommon: false },
  {
    label: "旅行速度（km/h）",
    key: "旅行速度",
    isSimple: true,
    isCommon: false,
  },
  {
    label: "交通調査基本区間世代管理番号",
    key: "交通調査基本区間世代管理番号",
    isSimple: false,
    isCommon: false,
  },
  {
    label: "交通調査基本区間バージョン",
    key: "交通調査基本区間バージョン",
    isSimple: false,
    isCommon: false,
  },
  {
    label: "都道府県コード",
    key: "都道府県コード",
    isSimple: false,
    isCommon: false,
  },
  {
    label: "道路種別コード",
    key: "道路種別コード",
    isSimple: false,
    isCommon: false,
  },
  { label: "路線番号", key: "路線番号", isSimple: false, isCommon: false },
  {
    label: "交通調査基本区間長（m）",
    key: "交通調査基本区間長",
    isSimple: false,
    isCommon: false,
  },
  {
    label: "旅行時間（秒）",
    key: "旅行時間",
    isSimple: false,
    isCommon: false,
  },
];

/**
 * 画面幅
 */
const VALUE_WIDTH = 420;

/**
 * 画面高さ
 */
const VALUE_HEIGTH = 300;

/**
 * 画面最大高さ
 */
const VALUE_MAX_HEIGHT = 500;

/**
 * 画面タイトル
 */
const VALUE_TITLE = "ETC2.0属性表示（交通調査基本区間-1ヵ月）";
/**
 * ETC2.0属性表示画面（交通調査区間-1ヵ月）属性取得クラス
 */
export class ETCLinkMonthSearchDateAttributeConvert
  implements ISearchDateAttributeConvert
{
  /**
   * GeoJSON
   */
  private _geoJSON: any;

  /**
   * ETCレイヤ名
   */
  private _layerName: string;

  /**
   * ETC道路種別コード
   */
  private _roadType: RoadType;

  /**
   * 時間コード
   */
  private _timeCode: string;

  /**
   * 平休日コード
   */
  private _dayType: DayType;

  /**
   * 共通項目
   */
  private commonItems: Array<{ key: string; value: string | number }>;

  /**
   * コンストラクタ
   * @param geoJSON GeoJSON
   * @param layerName ETCレイヤ名
   * @param roadType ETC道路種別
   * @param timeCode 時間コード
   * @param dayType 平休日コード
   * @param commonItems 共通項目
   */
  constructor(
    geoJSON: any,
    layerName: string,
    roadType: RoadType,
    timeCode: string,
    dayType: DayType,
    commonItems?: Array<{ key: string; value: string | number }>
  ) {
    this._geoJSON = geoJSON;
    this._layerName = layerName;
    this._roadType = roadType;
    this._timeCode = timeCode;
    this._dayType = dayType;
    this.commonItems = commonItems;
  }

  /**
   * 時間コード取得
   */
  getTimeCode(): string {
    return this._timeCode;
  }
  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FEATURE_TYPE;
  }
  /**
   * 属性データ更新
   * @param timeCode 時間コード
   */
  // 地物情報をtimeCodeで取得なおして、結果やtimeCodeを保持しておく
  async load(timeCode: string): Promise<ISearchDateAttributeConvert> {
    let cqlQuery = "";
    const feature = new GeoJSON().readFeatures(this._geoJSON)[0];
    const formattedTimeCode =
      timeCode.slice(0, 6) + "00" + timeCode.slice(8, 10) + "00";
    if (feature) {
      cqlQuery = `"道路種別コード"='${this._roadType}' AND "休平日区分"=${
        this._dayType
      } AND "時間コード"=${formattedTimeCode} AND "交通調査基本区間番号"='${feature.get(
        "交通調査基本区間番号"
      )}' AND "上り・下りコード"=${feature.get("上り・下りコード")}`;
    } else {
      cqlQuery =
        `"道路種別コード"='${this._roadType}' AND "休平日区分"=${this._dayType} AND "時間コード"=${formattedTimeCode} ` +
        `AND "交通調査基本区間番号"='${
          this.commonItems.find(
            (element) => element.key === "交通調査基本区間番号"
          ).value
        } '` +
        `AND "上り・下りコード"=${
          this.commonItems.find((element) => element.key === "上り・下りコード")
            .value
        } `;
    }

    const cqlParameter = new CqlParameter(this._layerName, cqlQuery);
    const WFSGetter = new WFSGetFeatureManager();
    const loadedGeoJSON = await WFSGetter.getInfo(URL_API, [
      cqlParameter,
    ]).catch((error) => {
      throw error;
    });

    if (new GeoJSON().readFeatures(loadedGeoJSON)[0]) {
      return new ETCLinkMonthSearchDateAttributeConvert(
        loadedGeoJSON,
        this._layerName,
        this._roadType,
        formattedTimeCode,
        this._dayType
      );
    } else {
      const commonItems: Array<{ key: string; value: string | number }> = [
        {
          key: "交通調査基本区間番号",
          value: feature
            ? feature.get("交通調査基本区間番号")
            : this.commonItems.find(
                (element) => element.key === "交通調査基本区間番号"
              ).value,
        },
        {
          key: "上り・下りコード",
          value: feature
            ? feature.get("上り・下りコード")
            : this.commonItems.find(
                (element) => element.key === "上り・下りコード"
              ).value,
        },
      ];

      return new ETCLinkMonthSearchDateAttributeConvert(
        loadedGeoJSON,
        this._layerName,
        this._roadType,
        formattedTimeCode,
        this._dayType,
        commonItems
      );
    }
  }

  /**
   * 画面用フォーマット取得
   */
  getViewFormatData(): AttributeView {
    const features = new GeoJSON().readFeatures(this._geoJSON);
    const attributeValues: AttributeValue[] = [];
    const { year, month, hour } = parseTimeCode(this._timeCode);

    if (features.length) {
      const feature = features[0];
      // 画面項目に基づき値を取得（値がない場合は"-"）
      PROPERTY_MAP.forEach((property) => {
        if (property.key === PROPERTY_MAP[1].key) {
          /**
           * 上り・下りコードを画面用文字列に変換する
           */
          attributeValues.push({
            key: property.label,
            value: ETCCodeUtil.toUpDownCodeViewString(
              feature.get(property.key)
            ),
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[2].key) {
          /**
           * 算定年月日
           */
          attributeValues.push({
            key: property.label,
            value: `${year}/${month}`,
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[3].key) {
          /**
           * 休平日区分を画面用文字列に変換する
           */
          attributeValues.push({
            key: property.label,
            value: ETCCodeUtil.toHoridayCodeViewString(
              feature.get(property.key)
            ),
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[4].key) {
          /**
           * 指定時間を設定
           */
          attributeValues.push({
            key: property.label,
            value: `${hour}:00`,
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[8].key) {
          /**
           * 都道府県を画面用文字列に変換する
           */
          attributeValues.push({
            key: property.label,
            value: ETCCodeUtil.toPrefectureCodeViewString(
              feature.get(property.key)
            ),
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[9].key) {
          /**
           * 道路種別コードを画面用文字列に変換する
           */
          attributeValues.push({
            key: property.label,
            value: ETCCodeUtil.toRoadTypeViewString(feature.get(property.key)),
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else {
          attributeValues.push({
            key: property.label,
            value: feature.get(property.key) ?? "-",
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        }
      });
    } else {
      // 画面項目に基づき値を取得（値がない場合は"-"）
      PROPERTY_MAP.forEach((property) => {
        if (property.key === PROPERTY_MAP[0].key) {
          /**
           * 交通調査基本区間番号
           */
          const value = this.commonItems.find(
            (element) => element.key === property.key
          ).value;
          attributeValues.push({
            key: property.label,
            value: value ? value.toString() : "-",
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[1].key) {
          /**
           * 上り・下りコードを画面用文字列に変換する
           */
          const value = this.commonItems.find(
            (element) => element.key === property.key
          ).value;
          attributeValues.push({
            key: property.label,
            value: ETCCodeUtil.toUpDownCodeViewString(value?.toString()),
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[2].key) {
          /**
           * 算定年月日
           */
          attributeValues.push({
            key: property.label,
            value: `${year}/${month}`,
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else if (property.key === PROPERTY_MAP[4].key) {
          /**
           * 指定時間を設定
           */
          attributeValues.push({
            key: property.label,
            value: `${hour}:00`,
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        } else {
          attributeValues.push({
            key: property.label,
            value: "-",
            isSimple: property.isSimple,
            isCommon: property.isCommon,
          });
        }
      });
    }

    const attributeView: AttributeView = {
      width: VALUE_WIDTH,
      height: VALUE_HEIGTH,
      maxheight: VALUE_MAX_HEIGHT,
      title: VALUE_TITLE,
      attributeValues: attributeValues,
      csvOutputUnPossibility: true,
      jsonOutputUnPossibility: true,
    };

    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = new GeoJSON().readFeatures(this._geoJSON)[0];
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }

  /**
   * ジオメトリを取得
   */
  getGeometry(): Geometry {
    const feature = new GeoJSON().readFeatures(this._geoJSON)[0];
    return feature?.getGeometry().transform("EPSG:3857", "EPSG:4326");
  }
}
